module.exports = __webpack_public_path__ + "img/23400.e0665472.jpg";